export default __webpack_public_path__ + "static/media/1024.cc9be4e1.png";